import OtpForm from '../components/auth/OtpForm';

export default function OtpPage() {
  return (
    <div className="otp-page">
      <div className="otp-page__bg" />
      <div className="otp-page__content">
        <OtpForm />
      </div>
    </div>
  );
}
